/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RrpUploadResultResponse
 */
export interface RrpUploadResultResponse {
    /**
     * 
     * @type {number}
     * @memberof RrpUploadResultResponse
     */
    updatedPriceListsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof RrpUploadResultResponse
     */
    updatedProductsCount?: number;
}

/**
 * Check if a given object implements the RrpUploadResultResponse interface.
 */
export function instanceOfRrpUploadResultResponse(value: object): value is RrpUploadResultResponse {
    return true;
}

export function RrpUploadResultResponseFromJSON(json: any): RrpUploadResultResponse {
    return RrpUploadResultResponseFromJSONTyped(json, false);
}

export function RrpUploadResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RrpUploadResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'updatedPriceListsCount': json['updatedPriceListsCount'] == null ? undefined : json['updatedPriceListsCount'],
        'updatedProductsCount': json['updatedProductsCount'] == null ? undefined : json['updatedProductsCount'],
    };
}

export function RrpUploadResultResponseToJSON(json: any): RrpUploadResultResponse {
    return RrpUploadResultResponseToJSONTyped(json, false);
}

export function RrpUploadResultResponseToJSONTyped(value?: RrpUploadResultResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updatedPriceListsCount': value['updatedPriceListsCount'],
        'updatedProductsCount': value['updatedProductsCount'],
    };
}

